export var WeeklyChart = {
  series: [
    {
      name: "Revenue",
      data: [76, 85, 101, 98, 87, 105, 91],
      color: "var(--primary-color)",
    },
    {
      name: "Free Cash Flow",
      data: [35, 41, 36, 26, 45, 48, 52],
      color: "var(--accent-color)",
    },
  ],
  chart: {
    type: "bar",
    height: 350,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40%",
      endingShape: "rounded",
      borderRadius: 10,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"],
  },
  xaxis: {
    categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    labels: {
    },
    axisTicks: {
      show: true,
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: ["#FF0000"], // Set y-axis label color (Red)
      },
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    theme: "dark",
    y: {
      formatter: function (val) {
        return "$ " + val + " thousands";
      },
    },
  },
  legend: {
    position: "top",
    show: true,
    horizontalAlign: "right",
  },
};
